import "./ImpactedToothSurgeries.module.css";
import Header from "@/reusable_sections/Header";
import LocalBusinessComparison from "./sections/LocalBusinessComparison";
import EndoskopiHakkinda from "./sections/EndoskopiHakkinda";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function ImpactedToothSurgeriesPage() {
  return <div>
      <Header />
      <LocalBusinessComparison />
      <EndoskopiHakkinda />
      <Projects />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}